import styled from "@emotion/styled"

export const ContentSidebarContainer = styled.div`
padding-right: 30px;
    padding-left: 30px;
    margin: 0 auto;
    @media(min-width: 576px){
        max-width: 540px;
    }
    @media(min-width: 768px){
        max-width: 720px;
    }
@media(min-width: 992px){
    display: grid;
    grid-gap: 30px;
    grid-template-columns: 66.6% 33.3%;
    max-width: 960px;
}
@media(min-width: 1200px){
    max-width: 1300px;
}
@media(min-width: 1920px){
    max-width: 1600px;
}
    img{max-width: 100%;}
    .underline{width: 100%;}
`
export const ContentSidebarContainerNoFeaturedImage = styled(ContentSidebarContainer)`
@media(min-width: 992px){
margin-top: 120px;
}
`
export const LineBottom = styled.div`
left: 0;
bottom: -12px;
right: auto;
transform: rotate(180deg);
position: relative;
@media(min-width: 768px){
    left: -163px;
}
`
export const HeaderSection = styled.div`
margin: 0 0 35px 0;
@media(min-width: 576px){
    margin: 80px 0 35px 0;
}
`
export const UnderlineMobile = styled.div`
@media(min-width: 992px){
    display: none;
}
`
export const UnderlineDesktop = styled.div`
display: none;
@media(min-width: 992px){
    display: block;
}
`
export const OverviewPageH4 = styled.h4`
margin-bottom: .5rem !important;

a{
    color: #444;
    
line-height: 1.2;
font-family: sans-serif;
font-size: 36px;
font-weight: 400;
}
`
export const ReadMore = styled.span`
color: #b6212a;
position: relative;
text-transform: uppercase;
font-size: 12px;

:after{
    content: "";
    position: absolute;
    left: auto;
    right: -50px;
    width: 30px;
    height: 1px;
    top: 50%;
    transform: translateX(-50%);
    background: #b6212a;
}
`
export const StyledArticle = styled.article`
margin-bottom: 30px;

@media(min-width: 768px){
    border-bottom: 1px solid #ccc;
    padding-bottom: 30px;
}
`
export const PrevNextButton = styled.button`
color: #b6212a;
font-size: 12px;
background: 0 0;
    border: 1px solid #b6212a;
    border-radius: 0;
    font-family: averta-bold;
    text-transform: uppercase;
    padding: 12px 46px;
    position: relative;
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    line-height: 1.5;
    -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;
    position: relative !important;
    overflow: visible;
    margin: 40px 0 1rem 0;
    transition: color .5s ease-in-out,background-color .5s ease-in-out,border-color .5s ease-in-out,box-shadow .5s ease-in-out;
    display: block;

    :after{
        content: "";
        position: absolute;
        width: calc(100% - 18px);
        height: 131%;
        left: 10px;
        right: 0;
        top: -7px; 
        border: 1px solid #b6212a;
    }

:hover{
    cursor: pointer;
    background-color: #b6212a;
    color: #fff;
}
@media(min-width: 768px){
    display: inline-block;
    :nth-of-type(2){
        margin-left: 20px;
    }
}
`